<template>
  <div :class="$options.name">
    <v-card :loading="isLoading" width="560">
      <v-img
        v-if="single.thumbnail"
        :src="single.thumbnail.path"
        class="white--text"
        height="200px"
        gradient="to bottom right, rgba(100,115,201,.33), rgba(25,32,72,.7)"
      >
        <v-card-title class="align-end fill-height">Редактирование категории</v-card-title>
      </v-img>
      <v-card-title v-else>Редактирование категории</v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            v-model="form.name"
            :value="single.name"
            :rules="rules.name"
            label="Название категории"
          />

          <icon-select-component
            v-model="form.iconId"
            :data="single.icon"
            :list="iconList"
            label="Иконка категории"
          />

          <v-file-input
            label="Изображение категории"
            accept="image/*"
            :success="thumbnailLoaded"
            :success-messages="thumbnailSuccessMessage"
            @change="onThumbnailChange"
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1" />
        <v-btn
          :loading="isLoading"
          :disabled="isLoading"
          color="green lighten-1"
          text
          @click="onUpdate"
        >
          Сохранить изменения
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import get from 'lodash/get';
import { uploadFile } from '@/utils/requests/upload';
import IconSelectComponent from '@/components/ui/icon-select';

const createDefaultForm = () => ({
  name: null,
  parentId: null,
  attachmentId: null,
  thumbnail: null,
  iconId: null,
});

export default {
  name: 'references-categories-item-view',
  asyncData({ store, route }) {
    const { id } = route.params;
    const actions = [
      store.dispatch('icons/getList'),
      store.dispatch('categories/getItem', id),
    ];

    return Promise.all(actions);
  },
  components: { IconSelectComponent },
  metaInfo() {
    return {
      title: this.single.name,
    };
  },
  data: () => ({
    valid: true,
    form: createDefaultForm(),
    rules: {
      name: [
        v => !!v || 'Поле обязательно для заполнения',
      ],
    },
    isLoading: false,
    thumbnailLoaded: false,
  }),
  computed: {
    ...mapState('categories', ['single']),
    ...mapState('icons', {
      iconList: 'list',
    }),

    thumbnailSuccessMessage() {
      return this.thumbnailLoaded ? ['Изображение успешно загружено. Сохраните изменения.'] : [];
    },
  },
  created() {
    this.updateForm();
  },
  methods: {
    ...mapActions('categories', ['update', 'getItem']),
    ...mapActions(['showNotify']),

    async onUpdate() {
      this.isLoading = true;

      if (this.$refs.form.validate()) {
        try {
          await this.update({ id: this.single.id, ...this.form });
          await this.getItem(this.single.id);
          this.showNotify({ message: 'Данные успешно обновлены' });
          this.updateForm();
        } catch (e) {
          console.error(e);
        }
      }

      this.isLoading = false;
    },

    async onThumbnailChange(file) {
      if (!file) { this.thumbnailLoaded = false; return; }

      this.thumbnailLoaded = false;
      this.isLoading = true;

      try {
        const response = await uploadFile(file);
        const { id } = response;

        this.form.attachmentId = id;
        this.thumbnailLoaded = true;
      } catch (e) {
        console.error(e);
      }

      this.isLoading = false;
    },

    updateForm() {
      this.form = {
        ...this.single,
        attachmentId: get(this.single, 'thumbnail.id'),
        iconId: get(this.single, 'icon.id'),
      };

      this.thumbnailLoaded = false;
    },
  },
};
</script>
